<script>
import MasterExtraOffer from '@components/master-extra-offer'

export default {
  components: { MasterExtraOffer },
  props: {
    extra: { type: Object, required: true },
  },
  data: () => ({
    showModal: false,
  }),
  computed: {
    heroImg() {
      const images = this.extra.images
      return images.length ? images[0].src : ''
    },
    carouselData() {
      return this.extra.images.map(
        (i) =>
          `<div
            class="bg-cover bg-center"
            style="background-image: url(${i.src}); height: 20rem;"
          />`
      )
    },
  },
}
</script>

<template>
  <div class="border border-gray-500 mb-6">
    <div class="py-4 px-3">
      <a
        class="font-medium cursor-pointer hover:underline"
        @click="showModal = true"
        >{{ extra.name }}</a
      >
    </div>
    <div class="bg-gray-100">
      <div class="flex flex-wrap">
        <div class="w-full md:w-3/12 px-3 mb-3">
          <div
            class="relative overflow-hidden my-3 cursor-pointer h-64 md:h-40"
          >
            <img
              :src="heroImg"
              :alt="extra.name"
              class="max-w-full w-full max-h-full h-full absolute inset-0"
              @click="showModal = true"
            />
          </div>
        </div>
        <!-- master extra info -->

        <MasterExtraOffer class="w-full md:w-9/12 px-3" :extra="extra" />
        <!-- master extra details -->
      </div>
    </div>

    <BaseModal v-model="showModal" :title="extra.name" size="3xl">
      <template v-if="showModal">
        <div class="mb-6">
          <Carousel :data="carouselData" :controls="true" />
        </div>

        <div class="flex flex-wrap">
          <div class="w-full">
            <h5 class="text-lg text-gold mb-4 border-b-2 border-gold-500">
              Description
            </h5>
            <p class="mb-6">{{ extra.description }}</p>
          </div>
        </div>
        <!-- Room Description -->
      </template>
    </BaseModal>
  </div>
</template>
